// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__EBQAX","btn":"Tabs_btn__OqtnT","active":"Tabs_active__hC6rb"};